import React from 'react';

import { Helmet } from 'react-helmet-async';

export default function DataDeletion() {
  return (
    <div className="page">
      <Helmet>
        Data Deletion - Homebrew Game Labs
      </Helmet>
      <header>
        <div className="logo">Homebrew <span>Labs</span></div>
        <h1>Data Deletion Policy</h1>
        <div className="effective-date">Effective Date: February 22, 2025</div>
      </header>
  
      <p>At <strong>Homebrew Game Labs</strong>, you are in control of your data. This page explains what data we store, how to request its deletion, and what happens when you do.</p>
  
      <h2>What Data We Store</h2>
      <p>When you use Homebrew Game Labs, we may store the following information associated with your account:</p>
      <ul>
        <li>Your name and email address (provided at registration or via Facebook Login)</li>
        <li>Your profile information from your identity provider (e.g., Facebook profile ID)</li>
        <li>D&D characters, campaign data, and other content you create within the app</li>
        <li>Account metadata such as creation date and last login</li>
      </ul>
  
      <h2>How to Request Data Deletion</h2>
      <p>You can request the deletion of your account and all associated data in either of the following ways:</p>
  
      <p><strong>Option 1 – Via Email</strong></p>
      <ol className="steps">
        <li>Send an email to <a href="mailto:privacy@homebrewlabs.app">privacy@homebrewlabs.app</a> with the subject line <em>"Data Deletion Request"</em>.</li>
        <li>Include the email address associated with your Homebrew Game Labs account so we can locate your data.</li>
        <li>We will confirm receipt of your request and process it within <strong>30 days</strong>.</li>
      </ol>
  
      <p><strong>Option 2 – Facebook Login Users</strong></p>
      <p>If you signed in using Facebook, you can also initiate a data deletion request directly through Facebook:</p>
      <ol className="steps">
        <li>Go to your <a href="https://www.facebook.com/settings?tab=applications" target="_blank">Facebook Settings &gt; Apps and Websites</a>.</li>
        <li>Find <strong>Homebrew Game Labs</strong> in the list and select <em>Remove</em>.</li>
        <li>Facebook will notify us of your deletion request, and we will remove your associated data within <strong>30 days</strong>.</li>
      </ol>
  
      <h2>What Gets Deleted</h2>
      <p>Upon a confirmed deletion request, we will permanently remove:</p>
      <ul>
        <li>Your account and login credentials from AWS Cognito</li>
        <li>Your personal profile information (name, email, linked social account IDs)</li>
        <li>All D&D characters, campaigns, and app content associated with your account</li>
      </ul>
  
      <h2>What May Be Retained</h2>
      <div className="callout">
        <p>In limited cases, some data may be retained beyond your deletion request where required by law or for legitimate operational purposes, such as fraud prevention or resolving disputes. Any retained data will not be used for any other purpose and will be deleted as soon as it is no longer needed.</p>
      </div>
  
      <h2>Confirmation</h2>
      <p>Once your data has been deleted, we will send a confirmation to the email address associated with your account. If you no longer have access to that email, please mention this in your deletion request and we will work with you to confirm another way.</p>
  
      <h2>Questions</h2>
      <p>If you have any questions about this policy or your data, please reach out to us at <a href="mailto:privacy@homebrewlabs.app">privacy@homebrewlabs.app</a>.</p>
  
      <footer>
        &copy; 2025 Homebrew Game Labs. All rights reserved.
      </footer>
    </div>
  );
}
